export default __webpack_public_path__ + "static/corona-2020-e5308f3200174efe4982c7e1699eb17d.svg";